import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/JLClub";

// Overlays - Path adjusted relative to this file
import test from "../assets/joylovers/top.png";
import left from "../assets/joylovers/Tree-overhead-overlay-VR1.png";
import logo from "../assets/wetu/Optiven @ 24.png";
import key from "../assets/joylovers/key.png";

const JoyLovers = () => {
  const projectId = "PRJ00057";
  const title = "JOY LOVERS CLUB - MALINDI";

  const mapConfig = {
    minZoom: 15,
    zoom: 16,
    bounds: [
      [40.66, -74],
      [40.64, -73.98],
    ],
    imageOverlays: [
        {
            imageUrl: test,
            imageBounds: [
              [40.65303, -73.99975],
              [40.64964, -73.99101],
            ],
          },
          {
            imageUrl: test, // Note: Original used 'test' image here too
            imageBounds: [
              [40.64492, -74.00293],
              [40.64098, -73.9871],
            ],
          },
          {
            imageUrl: left,
            imageBounds: [
              [40.65313, -74.00327],
              [40.64368, -73.99851],
            ],
          },
          {
            imageUrl: logo,
            imageBounds: [
              [40.65117, -73.98703],
              [40.64942, -73.98421],
            ],
          },
          {
            imageUrl: key,
            imageBounds: [
              [40.64737, -73.98808],
              [40.64434, -73.98401],
            ],
          },
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/joy-lovers-club-malindi/#max-widget"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSdxo2bW5ea0cbPiZaEFalvidlbmF0ajvbE8EtPtZMXKyIUp2w/viewform?pli=1"
    />
  );
};

export default JoyLovers;
